import styled from 'styled-components';
import Grid from '@lendi-ui/grid';
import { mt, pr } from '@lendi-ui/spacing';

// The reason of using margin top is that,
// CSS has a rule:
// if two elements are places vertical,
// the top element has margin bottom,
// the bottom element has margin top,
// CSS will combine the margins,
// if all margins are >= 0, the rendered margin will be the bigger one
// if all margins are < 0, the rendered margin will be the absolute value bigger one
// if a > 0 and b < 0, the rendered margin will be the a + b
export const ListItem = styled.div`
  display: block;
  ${mt('sm')}
`;

export const PaddedGridUnit = styled(Grid.Unit)`
  ${pr('xxs')}
`;
